/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EVerifyService {

    /**
     * Update E-Verify case based on case_action param
     * @param id E-Verify case id
     * @param requestBody
     * @returns any successful
     * @throws ApiError
     */
    public static patchInternalApiEverifyCases(
        id: string,
        requestBody: {
            case_action?: string;
        },
    ): CancelablePromise<{
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/internal_api/everify_cases/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `not found`,
                422: `unprocessable entity`,
                500: `internal server error`,
            },
        });
    }

    /**
     * Destroy E-Verify case
     * @param id E-Verify case id
     * @returns void
     * @throws ApiError
     */
    public static deleteInternalApiEverifyCases(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/internal_api/everify_cases/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Not Found`,
                422: `unprocessable entity`,
                500: `internal server error`,
            },
        });
    }

}